import { useStoreCategories } from '@psl/functions/seller/useStoreCategories';
import { WithID } from '../../../functions/firebase/rxfireExtensions';
import { Profile, StoreFront } from '../../../models/ClientModels';

export const useIsStoreInfoValid = (
  store: WithID<StoreFront>,
  profile: WithID<Profile>,
) => {
  const categories = useStoreCategories(store.id, profile);
  return Boolean(
    profile?.avatar &&
      store?.bio?.trim() &&
      store?.name &&
      categories != null &&
      categories.length > 0,
  );
};
